import { useCallback, useEffect, useRef, useState } from 'react'

import { MediaDeviceInfo } from './useMediaDevices'

export const useDeviceSelection = (
  currentDeviceId: string | null | undefined,
  devices: MediaDeviceInfo[],
  switchDevice: (id: string) => void,
): [string | undefined, (id: string | undefined) => void] => {
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | undefined>(
    undefined,
  )
  const hasUserSelected = useRef(false)

  useEffect(() => {
    if (currentDeviceId && !hasUserSelected.current) {
      // トラック作成後、システム規定のデバイスに同期する
      setSelectedDeviceId(currentDeviceId)
    } else if (!selectedDeviceId && !currentDeviceId && devices.length > 0) {
      // トラック作成前のフォールバック: "default" デバイスを優先
      const defaultDevice = devices.find(d => d.deviceId === 'default')
      setSelectedDeviceId(defaultDevice?.deviceId ?? devices[0]?.deviceId)
    }
  }, [currentDeviceId, devices, selectedDeviceId])

  useEffect(() => {
    if (!selectedDeviceId || selectedDeviceId === currentDeviceId) return
    // currentDeviceId が存在し、ユーザーが明示選択していない場合は
    // 同期中のため switchDevice を呼ばない（次レンダーで selectedDeviceId が同期される）
    if (currentDeviceId && !hasUserSelected.current) return
    switchDevice(selectedDeviceId)
  }, [selectedDeviceId, currentDeviceId, switchDevice])

  const handleSelect = useCallback((id: string | undefined) => {
    hasUserSelected.current = true
    setSelectedDeviceId(id)
  }, [])

  return [selectedDeviceId, handleSelect]
}
